import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ProductState } from './types'
import { ProductService } from '../../services/product/ProductService'

const initialState: ProductState = {
  productImage: null,
  isCreateProductLoading: false,
  isDeleteProductLoading: false,
  isGetAllProductsLoading: false,
  isGetProductByIdLoading: false,
  isUpdateProductLoading: false,
  isUpdateProductOrderLoading: false
}

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProductImage: (state, action: PayloadAction<File | null>) => {
      state.productImage = action.payload
    },
    resetProductState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProductService.getAllProductsAsyncThunk.pending, (state) => {
        state.isGetAllProductsLoading = true
      })
      .addCase(ProductService.getAllProductsAsyncThunk.rejected, (state) => {
        state.isGetAllProductsLoading = false
      })
      .addCase(ProductService.getAllProductsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllProductsLoading = false
        state.products = action.payload
      })
      .addCase(ProductService.getProductByIdAsyncThunk.pending, (state) => {
        state.isGetProductByIdLoading = true
      })
      .addCase(ProductService.getProductByIdAsyncThunk.rejected, (state) => {
        state.isGetProductByIdLoading = false
      })
      .addCase(ProductService.getProductByIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetProductByIdLoading = false
        state.product = action.payload.product
      })
      .addCase(ProductService.updateProductAsyncThunk.pending, (state) => {
        state.isUpdateProductLoading = true
      })
      .addCase(ProductService.updateProductAsyncThunk.rejected, (state) => {
        state.isUpdateProductLoading = false
      })
      .addCase(ProductService.updateProductAsyncThunk.fulfilled, (state) => {
        state.isUpdateProductLoading = false
      })
      .addCase(ProductService.updateProductOrderAsyncThunk.pending, (state) => {
        state.isUpdateProductOrderLoading = true
      })
      .addCase(ProductService.updateProductOrderAsyncThunk.rejected, (state) => {
        state.isUpdateProductOrderLoading = false
      })
      .addCase(ProductService.updateProductOrderAsyncThunk.fulfilled, (state) => {
        state.isUpdateProductOrderLoading = false
      })
      .addCase(ProductService.deleteProductAsyncThunk.pending, (state) => {
        state.isDeleteProductLoading = true
      })
      .addCase(ProductService.deleteProductAsyncThunk.rejected, (state) => {
        state.isDeleteProductLoading = false
      })
      .addCase(ProductService.deleteProductAsyncThunk.fulfilled, (state) => {
        state.isDeleteProductLoading = false
      })
      .addCase(ProductService.createProductAsyncThunk.pending, (state) => {
        state.isCreateProductLoading = true
      })
      .addCase(ProductService.createProductAsyncThunk.rejected, (state) => {
        state.isCreateProductLoading = false
      })
      .addCase(ProductService.createProductAsyncThunk.fulfilled, (state) => {
        state.isCreateProductLoading = false
      })
  }
})

export const { setProductImage, resetProductState } = slice.actions
export default slice.reducer
